export const mergeTwoObjects = (object1, object2, overrideKeys = []) => {
  const merged = { ...object1, ...object2 };
  overrideKeys.forEach((key) => {
    merged[key] = object2[key] || object1[key];
  });
  return merged;
};
